import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useEmailAccountSignature(accountId: string | undefined) {
  const { data: signatureHtml = '', isLoading } = useQuery({
    queryKey: ['email-account-signature', accountId],
    queryFn: async () => {
      if (!accountId) return '';
      const { data, error } = await supabase
        .from('email_accounts')
        .select('signature_html' as any)
        .eq('id', accountId)
        .single();
      if (error || !data) return '';
      return ((data as any).signature_html as string) || '';
    },
    enabled: !!accountId,
    staleTime: 5 * 60 * 1000,
  });

  return { signatureHtml, isLoading };
}
